import { apiEndpoint } from './apiEndpoint';
import { standardHeaders } from './standardHeaders';

export async function getJobInvoice(jobInvoiceId: string) {
  const response = await fetch(`${apiEndpoint}/invoices/${jobInvoiceId}`, {
    method: 'GET',
    headers: await standardHeaders(),
    mode: 'cors',
  });
  if (response.ok) {
    return await response.json();
  }
  return null;
}

export async function getJobInvoiceByJobId(jobId: string) {
  const response = await fetch(`${apiEndpoint}/jobs/${jobId}/invoices`, {
    method: 'GET',
    headers: await standardHeaders(),
    mode: 'cors',
  });
  if (response.ok) {
    return await response.json();
  }
  return null;
}
